import { Divider as AntdDivider, DividerProps } from 'antd'

export const Divider = (props: DividerProps) => <AntdDivider {...props} />
